import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect,  ofType} from '@ngrx/effects';
import {debug} from '../../../rxjs-operators';
import {Country} from '../models/country';
import {BaseEffect} from './base.effect';
import {SendBackResult} from '../models/send-back-result';
import {ArrayResponse} from '../models/array-response';
import {error} from '../actions/toasts';
import {catchError, map, switchMap, take} from 'rxjs/operators';
import {countriesActionTypes, LoadCountriesFailAction, LoadCountriesSuccessAction} from '../actions/countries';
import {CountriesService} from '../services/countries.service';
import {L10nTranslationService} from 'angular-l10n';
import {of} from 'rxjs';
import {ApiCacheService} from '../services/cache.service';

@Injectable()
export class CountriesEffect extends BaseEffect {


  load$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(countriesActionTypes.LOAD),
      debug('Load countries action received;'),
      switchMap(() => {
        const cacheKey = 'countries'; // Unique cache key for countries
        const cached = this.apiCacheService.get<Country[]>(cacheKey);

        if (cached) {
          // Return cached data immediately
          return of(new LoadCountriesSuccessAction(cached));
        }

        return this.countriesService.getList().pipe(
          map((payload: SendBackResult<ArrayResponse<Country>>) => {
            const countries = payload.data.array;
            this.apiCacheService.set(cacheKey, countries); // Cache the response
            return new LoadCountriesSuccessAction(countries);
          }),
          catchError(res => this.catchResponseError(res))
        );
      }),
      take(1)
    );
  });


  loadFail$ = createEffect(() => { return this.actions$.pipe(
    ofType(countriesActionTypes.LOAD_FAIL),
    debug('Load countries fail action received.'),
    map((action: LoadCountriesFailAction) =>
      error(this.translation.translate('COUNTRIES_LOAD_ERROR') + '  ' + action.payload, this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              private countriesService: CountriesService,
              router: Router,
              private apiCacheService: ApiCacheService
  ) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new LoadCountriesFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new LoadCountriesFailAction(response['error'].message);
  }
}
